import React from "react";
import styled from "styled-components";

interface NewsItem {
  news_id: number;
  news_title: string;
  news_description: string;
  news_cover_path: string;
}

interface HomePageBannerProps {
  newsItem?: NewsItem | null;
}

const StyledBox = styled.div`
  height: 368px;
  width: 100%;
  max-width: 984px;
  margin-bottom: 20px;
  position: relative;
`;

const BannerView = styled.div<{ backgroundImage: string }>`
  background-image: url('${props => props.backgroundImage}');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
  border-radius: 16px;
  position: relative;
`;

const NewsOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
  border-radius: 0 0 16px 16px;
  padding: 30px 20px 20px;
`;

const NewsTitle = styled.h3`
  color: white;
  font-size: 24px;
  font-weight: bold;
  margin: 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
  line-height: 1.2;
`;

export const HomePageBanner: React.FC<HomePageBannerProps> = ({ newsItem }) => {
  const backgroundImage = newsItem 
    ? `${newsItem.news_cover_path}`
    : '/media/vertical_banner.svg';

  return (
    <StyledBox>
      <BannerView backgroundImage={backgroundImage}>
        {newsItem && (
          <NewsOverlay>
            <NewsTitle>{newsItem.news_title}</NewsTitle>
          </NewsOverlay>
        )}
      </BannerView>
    </StyledBox>
  );
};